import { Button } from 'primereact/button';
import { ButtonGroup } from 'primereact/buttongroup';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

const MenuPage = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentLocation = useLocation();

    const menus = [
        { label: "실시간메시지", path: "/chat" },
        { label: "강의자료", path: "/list" },
        { label: "동영상강의", path: "/lecture" },
        { label: "게시판", path: "/board" },
        { label: "공지사항", path: "/notice" },
    ];


    const handleLogout = () => {
        if (window.confirm('로그아웃 할까요??')) {
            dispatch({ type: 'logout' });
            navigate(`/`);
        }
    };

    // const handleShare = () => {
    //     window.open('https://ihongss.com:8443', '_blank', 'noopener,noreferrer');
    // };


    return (
        <ButtonGroup>
            {menus.map((item) => (
                <Button
                    key={item.path}
                    severity={
                        currentLocation.pathname === item.path ? "success": "secondary"
                    }
                    onClick={() => navigate(item.path)}
                >
                    {item.label}
                </Button>
            ))}

            {/* <Button onClick={handleShare} severity='secondary'>화면공유</Button> */}
            <Button onClick={handleLogout} severity='secondary'>로그아웃</Button>
        </ButtonGroup>
    );
};

export default MenuPage;
